import { useDebounce } from 'use-debounce';
import useSearchFriends from '@/hooks/search/use-search-friends';
import useSearchGroupMembers from '@/hooks/search/use-search-group-members';
import useSearchMessages from '@/hooks/search/use-search-messages';

export default function useGlobalSearch(keyword = '') {
  const [debouncedKeyword] = useDebounce(keyword, 300);
  const { messages, isLoading: isLoadingMessages } = useSearchMessages(debouncedKeyword);
  const { groupMembers, isLoading: isLoadingUsers } = useSearchGroupMembers(debouncedKeyword);
  const { filteredFriends, isLoading: isLoadingFriends } = useSearchFriends(debouncedKeyword, {
    searchIncludeTags: true,
  });

  const isLoading = isLoadingMessages || isLoadingUsers || isLoadingFriends;

  return {
    messages,
    groupMembers,
    friends: filteredFriends,
    isLoading,
  };
}

export type GlobalSearchReducerActionType = 'all' | 'messages' | 'groups' | 'friends';
